import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// d.ts
import { DCRecord, IDataController } from "@/@types/lib/dataController"

// Custom Components
import ModelTable from "@/ui/Table/ModelTable";
import TableButtonEdit from "@/ui/Table/ActionButtons/TableButtonEdit";
import DialogContext from "@/ui/DialogContext/DialogContext";
import LoaderContext from "@/components/LoaderContext/LoaderContext";
import model from "@/models/planinarska_udruga";
import dataController from "@/lib/dataController";
import PlaninarskaUdrugaDialog from "./PlaninarskaUdrugaDialog"

import { DialogContextType } from "@/@types/ui/DialogContext";
import { LoaderContextType } from "@/@types/context/LoaderContext";
import { Permissions } from "@/lib/permissions";
import UserContext from "@/components/UserContext/UserContext";
import { UserContextType } from "@/@types/context/UserContext";

function PlaninarskeUdrugeTable() {
  const dialogContext = useContext<DialogContextType>(DialogContext);
  const loaderContext = useContext(LoaderContext) as LoaderContextType;
  const userContext = useContext(UserContext) as UserContextType;

  const { t } = useTranslation();

  const [records, setRecords] = useState<DCRecord[]>([]);

  const dc: IDataController = new dataController(model);

  useEffect(() => {
    refreshRecords();
  }, []);

  const handleAdd = () => {
    dialogContext.showDialog(PlaninarskaUdrugaDialog, {
      dc: dc,
      mode: "insert",
      form: "insert",
      onClose: handleDialogClose
    });
  };

  const handleEdit = (evt: React.SyntheticEvent, sel: string[]) => {
    const selId: number = parseInt(sel[0], 10);
    const record: DCRecord = records[selId];
    dialogContext.showDialog(PlaninarskaUdrugaDialog, {
      dc: dc,
      mode: "update",
      form: "update",
      recordId: record.id,
      onClose: handleDialogClose
    });
  };

  const handleDialogClose = (result: { dataChanged: boolean; action: string }) => {
    if (result.dataChanged) {
      refreshRecords();
    }
  };

  const refreshRecords = () => {
    loaderContext.toggleLoading(true);
    dc.GetData().then((resp) => {
      if (resp.success) {
        if (Array.isArray(resp.data)) {
          setRecords(resp.data)
        }
        else {
          setRecords([]);
        }
      };
    }).finally(() => {
      loaderContext.toggleLoading(false);
    });
  };

  const canEdit = userContext.hasAnyPermission([Permissions.Administration, Permissions.HPSKomisijaView]);

  const hasCountRights = userContext.hasAnyPermission([Permissions.Administration, Permissions.HPSKomisijaView]);

  const viewName = hasCountRights ? "admin" : "default";

  return (
    <ModelTable
      title={t("titles.plan_udruge")}
      records={records}
      dc={dc}
      viewName={viewName}
      allowSelection={canEdit ? "one" : "none"}
      allowFilter
      allowExport={canEdit}
      allowAdd={canEdit}
      addLabel={t("buttons.new_f")}
      handleAdd={handleAdd}
      onRowAction={() => { }}
      allowRowAction={() => true}
    >
      <TableButtonEdit variant="contained" onClick={handleEdit} needPermission={[Permissions.Administration, Permissions.HPSKomisijaView]} />
    </ModelTable>
  );
}

export default PlaninarskeUdrugeTable;
